// Both shells draw the Actions pages and the settings form, and the form is
// also the viewer's Run dialog in either theme. The community tokens (--tr-*)
// apply where the shell defines them (its light pages and its dark viewer
// both do); the app's own palette stands in otherwise (the enterprise shell).

export const ink = 'text-[color:var(--tr-ink,var(--foreground))]';
export const muted = 'text-[color:var(--tr-muted,var(--muted-foreground))]';
export const hint = 'text-[color:var(--tr-hint,var(--muted-foreground))]';
export const line = 'border-[color:var(--tr-line,var(--border))]';
export const divide = 'divide-[color:var(--tr-line,var(--border))]';
export const surface = 'bg-[color:var(--tr-surface,var(--card))]';
export const page = 'bg-[color:var(--tr-page,var(--background))]';
export const hover = 'hover:bg-[color:var(--tr-hover,var(--accent))]';

/** The page title, at the shell's size: community defines --tr-title (24 px, tight); the app's pages use 18 px. */
export const title = 'text-[length:var(--tr-title,1.125rem)] font-semibold leading-tight tracking-[var(--tr-title-tracking,0)]';
/** A section's heading, and a card's name. */
export const heading = 'text-[15px] font-semibold leading-snug';
/** Secondary words: a publisher line, the words under a label, a count. Never smaller than this on a page. */
export const small = 'text-[13px] leading-snug';

/** The words that lead a setting's rows ("Default", "Customization range"): one width, so the rows' controls line up. */
export const lead = 'w-36 shrink-0 text-[13px] leading-snug text-[color:var(--tr-muted,var(--muted-foreground))]';

// ── sliders ──────────────────────────────────────────────────────────────────
// A slider is our own track (a line, with the part that is "in" filled) and a
// range input drawn as its thumb alone, so the value slider and the band of
// what runs may use look the same and sit on the same scale.

/** The line a slider runs along. */
export const track = 'bg-[color:var(--tr-line-2,var(--border))]';
/** The part of the line that is in: up to the value, or between the band's ends. */
export const trackFill = 'bg-[color:var(--tr-ink,var(--primary))]';
/** A range input over our track: its own track hidden, its thumb a ring in the page colour. */
export const thumb =
  'm-0 h-full w-full appearance-none bg-transparent outline-none disabled:cursor-not-allowed disabled:opacity-50 ' +
  '[&::-webkit-slider-runnable-track]:bg-transparent [&::-moz-range-track]:bg-transparent ' +
  '[&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full ' +
  '[&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-[color:var(--tr-ink,var(--primary))] ' +
  '[&::-webkit-slider-thumb]:bg-[color:var(--tr-page,var(--background))] [&::-webkit-slider-thumb]:shadow-sm [&::-webkit-slider-thumb]:cursor-pointer ' +
  '[&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-2 ' +
  '[&::-moz-range-thumb]:border-[color:var(--tr-ink,var(--primary))] [&::-moz-range-thumb]:bg-[color:var(--tr-page,var(--background))] [&::-moz-range-thumb]:cursor-pointer ' +
  // Focus from the keyboard: a soft ring round the thumb, never a box round the track.
  '[&:focus-visible::-webkit-slider-thumb]:shadow-[0_0_0_3px_var(--tr-line-2,var(--ring))] [&:focus-visible::-moz-range-thumb]:shadow-[0_0_0_3px_var(--tr-line-2,var(--ring))]';
